export default __webpack_public_path__ + "static/media/dashboard-shot.3ff11930.jpg";